import createReducer from 'shared/utils/createReducer';
import requestsStatuses from 'modules/common/constants/requestsStatuses';

import { ACCEPT_RESCHEDULING_OFFER } from '../actions/acceptReschedulingOffer';
import { DECLINE_RESCHEDULING_OFFER } from '../actions/declineReschedulingOffer';
import { GET_RESCHEDULING_OFFER } from '../actions/getReschedulingOffer';
import { SET_EXPIRED } from '../actions/setExpired';

const defaultState = {
  status: requestsStatuses.default,
  acceptStatus: requestsStatuses.default,
  declineStatus: requestsStatuses.default,
  message: null,
  organizationName: null,
  isAccepted: false,
  isDeclined: false,
  isExpired: false,
};

export default createReducer(defaultState, {
  [GET_RESCHEDULING_OFFER.failure]: (state, { payload: { apiErrorCodes } }) => ({
    ...state,
    status: requestsStatuses.failure,
    apiErrorCodes,
  }),
  [GET_RESCHEDULING_OFFER.pending]: () => ({
    ...defaultState,
    status: requestsStatuses.pending,
  }),
  [GET_RESCHEDULING_OFFER.success]: (state, { payload: { message, organizationName } }) => ({
    ...state,
    status: requestsStatuses.success,
    organizationName,
    message,
  }),

  [DECLINE_RESCHEDULING_OFFER.failure]: (state) => ({
    ...state,
    declineStatus: requestsStatuses.failure,
  }),
  [DECLINE_RESCHEDULING_OFFER.pending]: (state) => ({
    ...state,
    declineStatus: requestsStatuses.pending,
  }),
  [DECLINE_RESCHEDULING_OFFER.success]: (state, { payload: { message, organizationName } }) => ({
    ...state,
    declineStatus: requestsStatuses.success,
    message,
    organizationName,
    isDeclined: true,
  }),

  [ACCEPT_RESCHEDULING_OFFER.failure]: (state) => ({
    ...state,
    acceptStatus: requestsStatuses.failure,
  }),
  [ACCEPT_RESCHEDULING_OFFER.pending]: (state) => ({
    ...state,
    acceptStatus: requestsStatuses.pending,
  }),
  [ACCEPT_RESCHEDULING_OFFER.success]: (state, { payload: { message, organizationName } }) => ({
    ...state,
    acceptStatus: requestsStatuses.success,
    message,
    organizationName,
    isAccepted: true,
  }),

  [SET_EXPIRED]: (state, { payload: { message, organizationName } }) => ({
    ...state,
    status: requestsStatuses.success,
    acceptStatus: requestsStatuses.success,
    declineStatus: requestsStatuses.success,
    message,
    organizationName,
    isExpired: true,
  }),
});
